import React, {useRef, useState, useEffect} from 'react';
import {
  Box,
  Flex,
  Stack,
  Radio,
  Button,
  RadioGroup,
  Heading,
  Checkbox,
  Divider,
  Spacer,
  Link,
  StackDivider,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Thead,
  TableContainer,
  Tbody,
  Tr,
  Td,
} from '@chakra-ui/react';
import {set, useForm} from 'react-hook-form';
import BoxCard from '../../components/General/BoxCard';
import {CustomButton, CustomInput, SubmitButton, DatePicker, CustomCheckbox} from '../../components/General/FormInputs';
import {Navigate, useNavigate} from 'react-router-dom';
import LinkButton from '../../components/General/LinkButton';
import ServiceTypeList from '../../components/General/ServiceTypeList';
import {post, get, queryStringBuilder, getFile} from '../../service/ApiService';
import {Report, SurveyPrints} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import {getUserInfo} from '../../helpers/localStorage';
import {ClientSelect} from '../../components/Client/ClientSelect';
import ModalYesNo from '../../components/General/ModalYesNo';
import {check, getFileInfo} from 'prettier';
import {setGrid} from '../../helpers/SetGrid';
import {getCodeByKey} from '../../helpers/ServiceTypeDictionary';
import LoadingWheel from '../../components/General/LoadingWheel';
const SurveyPrint = () => {
  const [survey, setSurvey] = useState(1);
  // const [CFSSummary, setCFS] = useState(1);
  const [surveyType, setSurveyType] = useState('1');
  // const [preNeed, setPreNeed] = useState(1);
  const navigate = useNavigate();
  const [toast, setToast] = useState('');
  const [pdfUrl, setPdfUrl] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const linkRef = useRef(null);
  const [missingReportData, setMissingReportData] = useState([]);
  const [pages, setPages] = useState({
    pageNum: 1,
    totalPages: 1,
    itemsPerPage: 500,
    getNewPage: curPage => {
      loadData(curPage);
    },
  });
  const [isDisabled, setIsDisabled] = useState(true);
  // hard coded for now, but needs to be either passed in from user, or picked from dropdown.
  const clientid = '67';
  const ReportType = 1;
  const {
    register,
    handleSubmit,
    control,
    getValues,
    formState: {errors},
  } = useForm();
  // const {isOpen, onOpen, onClose} = useDisclosure();
  const {isOpen: isOpenRegModal, onOpen: OnOpenRegModal, onClose: onCloseRegModal} = useDisclosure();
  const {isOpen: isOpenReportModal, onOpen: onOpenReportModal, onClose: onCloseReportModal} = useDisclosure();
  // display missing reports.
  useEffect(() => {
    if (pdfUrl.length > 0) linkRef.current.click();
  }, [pdfUrl]);

  const loadData = async () => {
    const svcType = location?.state?.serviceType.value ?? 1;
    setServiceType(svcType);

    // initial search values
    const queryParams = {
      Page: 1,
      PageSize: 10,
      ServiceType: svcType,
      OrderBy: 'ContractDate',
      IsDescendingSort: true,
    };
    queryData(queryParams);
  };

  const filledCheck = () => {
    // initially made it using jquery syntax before realizing that there is no jquery. found my js only solution here: https://stackoverflow.com/questions/588263/how-can-i-get-all-a-forms-values-that-would-be-submitted-without-submitting

    // this grabs the elements value and then diables the disable
    const formEl = document.forms.Survey;
    const formData = new FormData(formEl);
    const sDate = formData.get('startDate');
    const eDate = formData.get('endDate');
    const radios = document.getElementsByName('radio');

    let radio = document.createElement('radio');
    for (let x = 0; x < radios.length; x++) {
      if (radios[x].checked) {
        radio = radios.item(x);
      }
    }
    if (sDate != null && eDate != null && radio != null) {
      setIsDisabled(false);
    }
  };

  async function update(data) {
    const url = `${SurveyPrints.Update}/${data.ServiceType}`;
    const params = {
      endDate: data.endDate,

      startDate: data.startDate,

      isCanada: data.isCanada,
      isElectronic: data.isElectronic,
      letterDate: data.letterDate,
    };
    return await post(url, params);
  }

  async function UnUpdateClick() {
    handleSubmit(async data => {
      const params = {
        endDate: data.endDate,

        startDate: data.startDate,

        isCanada: data.isCanada,
        isElectronic: data.isElectronic,
        letterDate: data.letterDate,
      };
      const url = `${SurveyPrints.UnUpdate}/${data.ServiceType}`;
      const response = await post(url, params);
      setToast({response: response, successMessage: 'Success'});
    })();
  }

  async function PrintLetter() {
    setIsLoading(true);
    const submit = handleSubmit(async data => {
      data.CsvcType = getCodeByKey(data.ServiceType);
      data.ReportType = 2;

      // this was needed at one point, not sure if it is anymore
      const urlCheck = queryStringBuilder(SurveyPrints.reportbuttonFileStatus, data);
      const checkResponse = await get(urlCheck);
      if (!checkResponse.error) {
        if (checkResponse.missingReports?.length > 0) {
          setMissingReportData(checkResponse.missingReports);
          onOpenReportModal();
          // setmissingReportElements(checkResponse.missingReports);
        }
      }

      const url = queryStringBuilder(`${Report.GET_SURVEY_LETTERS}`, data);
      const response = await getFile(url);

      setIsLoading(false);
      if (!response.error) {
        const fileURL = window.URL.createObjectURL(response);
        setPdfUrl(fileURL);
      } else {
        setToast(response);
      }
      // } else {
      //   setToast(checkResponse);
      // }
    });
    await submit();
    setIsLoading(false);
  }

  async function PrintSurvey() {
    setIsLoading(true);
    const submit = handleSubmit(async data => {
      data.CsvcType = getCodeByKey(data.ServiceType);
      data.ReportType = 1;

      // This was needed at one point, not sure if it is anymore
      const urlCheck = queryStringBuilder(SurveyPrints.reportbuttonFileStatus, data);
      const checkResponse = await get(urlCheck);
      if (!checkResponse.error) {
        if (checkResponse.missingReports?.length > 0) {
          setMissingReportData(checkResponse.missingReports);
          onOpenReportModal();
        }
      }
      const url = queryStringBuilder(`${Report.GET_SURVEYS}`, data);
      const response = await getFile(url);

      setIsLoading(false);
      if (!response.error) {
        const fileURL = window.URL.createObjectURL(response);
        setPdfUrl(fileURL);
      } else {
        setToast(response);
      }
      // } else {
      //   setToast(checkResponse);
      // }
    });
    await submit();
    setIsLoading(false);
  }

  async function PrintList() {
    setIsLoading(true);
    const submit = handleSubmit(async data => {
      data.CsvcType = getCodeByKey(data.ServiceType);
      const url = queryStringBuilder(`${Report.DEFAULT_REPORT}surveyL.rdlx`, data);
      const response = await getFile(url);
      if (!response.error) {
        const fileURL = window.URL.createObjectURL(response);
        setPdfUrl(fileURL);
        // return fileURL;
      } else {
        setToast({response: response});
      }
    });
    await submit();
    setIsLoading(false);
  }
  async function RegistrationNumbers() {
    handleSubmit(async data => {
      const updateResponse = await update(data);
      const params = {
        StartDate: data.startDate,
        EndDate: data.endDate,
        LetterDate: data.letterDate,
      };
      const url = `${SurveyPrints.SendRegNumbers}`;
      const response = await post(url);
      setToast(response);
      const emailurl = queryStringBuilder(SurveyPrints.SendRegEmailsButton);
      const emailResponse = await post(emailurl, params);
      setToast({response: emailResponse, successMessage: 'Emails/texts processing.'});
      onCloseRegModal();
    })();
  }

  return (
    <form id="Survey" onChange={filledCheck} /* {onSubmit={handleSubmit(printSurvey)} }*/>
      <Flex flexDir={{base: 'column', lg: 'row'}}>
        {/* Survey Printing */}
        <Box w="75%" mr="3" alignContent="center">
          <BoxCard>
            <Heading>Survey Printing</Heading>
            <Divider my="3" />

            <Flex>
              <DatePicker id="startDate" name="Starting Date" register={register} errors={errors} required mx="3" />
              <DatePicker id="endDate" name="Ending Date" register={register} errors={errors} required mx="3" />
              <DatePicker id="letterDate" name="Date for Survey Letter" register={register} errors={errors} mx="3" required />
              <Flex mt="7" ml="2">
                <CustomCheckbox control={control} id="isCanada" name="Canada" alignContent="left" />
              </Flex>
            </Flex>
            <Divider my="3" />
            {/* <Flex>
              <CustomCheckbox control={control} id="isFrench" name="French Mortuary: French" mx="3" />
              <CustomCheckbox control={control} id="isCanada" name="Canada" mx="3" />
              <CustomCheckbox control={control} id="isElectronic" name="Electronic Surveys: Wichmann" mx="3" />
              <CustomCheckbox control={control} id="isSpanish" name="Spanish Surveys: Buncker" mx="3" />
            </Flex> */}
            <Divider my="3" />
            <Box>
              <Heading size="md" mb="3" textAlign="start">
                Survey type
              </Heading>
              <ServiceTypeList control={control} />
            </Box>
            <Divider my="3" />
            <Flex>
              {isLoading ? (
                <LoadingWheel />
              ) : (
                <>
                  <Box w="10%" margin="0.5">
                    <LinkButton id="formButton" to="/reports" register={register} label="Back" />
                  </Box>
                  <Button colorScheme="secondary" mx="3" onClick={PrintLetter}>
                    Print Letter
                  </Button>
                  <Button colorScheme="secondary" mx="3" onClick={PrintSurvey}>
                    Print Survey
                  </Button>
                  <Button id="formButton" colorScheme="secondary" mx="3" onClick={PrintList}>
                    Print List
                  </Button>
                  <Button colorScheme="secondary" onClick={OnOpenRegModal} mx="3">
                    Update
                  </Button>
                  <Button colorScheme="secondary" onClick={UnUpdateClick} mx="3">
                    Un-Update
                  </Button>
                </>
              )}
              <ModalYesNo
                isOpen={isOpenRegModal}
                onOpen={OnOpenRegModal}
                onClose={onCloseRegModal}
                title="Confirmation"
                body={'Are you sure you want to send electronic emails and texts?'}
                yesFunction={RegistrationNumbers}
              />
              <Spacer />

              {/* <Box w="17%" margin="0.5">
                <SubmitButton id="formButton" register={register} errors={errors} name="Un-Update" />
              </Box>
              <Spacer />
              <Spacer />
              <Box w="17%" margin="0.5">
                <SubmitButton id="formButton" register={register} errors={errors} name="Registration numbers" />
              </Box> */}
              <Spacer />
              {/* <Box w="17%">
                <a href="https://fsrgsurvey.com/">
                  <Button w="100%" _hover={{color: 'white', textDecoration: 'none', bg: 'secondary.600'}} colorScheme="secondary">
                    fsrgsurvey.com
                  </Button>
                </a>
              </Box> */}
            </Flex>
          </BoxCard>
          <Modal blockScrollOnMount={false} size={'4xl'} isOpen={isOpenReportModal} onClose={onCloseReportModal}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader id="header">Missing Reports</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Divider mt="5" colorScheme={'mint'} width={{base: '100%'}} />
                <TableContainer width={{base: '100%'}}>
                  <Table variant="striped" border="solid 2px #0c5f78" colorScheme="mint" size={'md'}>
                    <Thead>
                      <Tr border="solid 2px #0c5f78">
                        <Td>ClientID</Td>
                        <Td>Report Name</Td>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {missingReportData.map(missingreport => {
                        return (
                          <Tr key={missingreport.clId}>
                            <Td>{missingreport.clId}</Td>
                            <Td>{missingreport.reportName}</Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </ModalBody>

              <ModalFooter>
                <CustomButton name="Close" mr={3} onClick={onCloseReportModal} />
              </ModalFooter>
            </ModalContent>
          </Modal>
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer" ref={linkRef} style={{display: 'none'}} />
        </Box>
      </Flex>
      <ErrorHelper toastResponse={toast} />
    </form>
  );
};

export default SurveyPrint;
